module.exports = __webpack_public_path__ + "antenniste.140b0636eaeed0371439148005bfcf51.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/base/components/home/antenniste.png
// module id = 277
// module chunks = 0